import { render, staticRenderFns } from "./deleteResourceStore.vue?vue&type=template&id=d322cf36&scoped=true"
import script from "./deleteResourceStore.vue?vue&type=script&lang=js"
export * from "./deleteResourceStore.vue?vue&type=script&lang=js"
import style0 from "./deleteResourceStore.vue?vue&type=style&index=0&id=d322cf36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d322cf36",
  null
  
)

export default component.exports